import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { I18nPipe } from '../../pipes/i18n.pipe';
import { I18nService } from '../../../core/services/i18n.service';

// ... interfaces permanecem as mesmas ...
export interface PasswordRequirements {
  minLength: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasSpecialChar: boolean;
  hasNumber: boolean;
}

interface RequirementItem {
  key: keyof PasswordRequirements;
  text: string;
  isValid: boolean;
}

@Component({
  selector: 'umkt-password-requirements',
  standalone: true,
  imports: [CommonModule, I18nPipe],
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.scss']
})
export class PasswordRequirementsComponent implements OnInit, OnChanges, OnDestroy {
  // NOVA PROPRIEDADE: Controla o estado inicial
  @Input() isPristine: boolean = true;

  @Input() requirements: PasswordRequirements = {
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasSpecialChar: false,
    hasNumber: false
  };

  requirementsList: RequirementItem[] = [];

  private i18nService = inject(I18nService);
  private langSubscription?: Subscription;

  ngOnInit(): void {
    this.langSubscription = this.i18nService.getCurrentLanguage().subscribe(() => {
      this.updateRequirementsList();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['requirements']) {
      this.updateRequirementsList();
    }
  }

  ngOnDestroy(): void {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  private updateRequirementsList(): void {
    const requirementTexts: Record<keyof PasswordRequirements, string> = {
      minLength: this.i18nService.instant('components.passwordRequirements.minLength'),
      hasUpperCase: this.i18nService.instant('components.passwordRequirements.upperCase'),
      hasLowerCase: this.i18nService.instant('components.passwordRequirements.lowerCase'),
      hasNumber: this.i18nService.instant('components.passwordRequirements.number'),
      hasSpecialChar: this.i18nService.instant('components.passwordRequirements.specialChar'),
    };

    const order: (keyof PasswordRequirements)[] = [
      'minLength',
      'hasSpecialChar',
      'hasUpperCase',
      'hasNumber',
      'hasLowerCase',
    ];
    
    this.requirementsList = order.map(key => ({
      key,
      text: requirementTexts[key],
      isValid: this.requirements[key]
    }));
  }
}
